import type {
  CurrencyCode,
  InvoiceRecord,
  PaymentQrAssetMap,
  PaymentQrAssetMeta,
  PaymentQrMethod,
  PaymentQrSettings,
} from "@/domain/types";

export function defaultPaymentQrSettings(
  currency: CurrencyCode,
  assets?: PaymentQrAssetMap,
): PaymentQrSettings {
  const gcashEnabled = currency === "PHP" && Boolean(assets?.gcash.hasImage);
  const maribankEnabled = currency === "PHP" && Boolean(assets?.maribank.hasImage);
  return {
    gcashEnabled,
    maribankEnabled,
    preferred: gcashEnabled ? "gcash" : maribankEnabled ? "maribank" : "gcash",
  };
}

export function enabledPaymentQrMethods(
  settings: PaymentQrSettings,
  assets?: PaymentQrAssetMap,
): PaymentQrMethod[] {
  const methods: PaymentQrMethod[] = [];
  if (settings.gcashEnabled && (assets?.gcash.hasImage ?? true)) methods.push("gcash");
  if (settings.maribankEnabled && (assets?.maribank.hasImage ?? true)) methods.push("maribank");
  return methods;
}

export function preferredEnabledPaymentQrMethod(
  settings: PaymentQrSettings,
  assets?: PaymentQrAssetMap,
): PaymentQrMethod | null {
  const enabled = enabledPaymentQrMethods(settings, assets);
  if (enabled.length === 0) return null;
  return enabled.includes(settings.preferred)
    ? settings.preferred
    : enabled[0] ?? null;
}

export function paymentQrAsset(
  invoice: InvoiceRecord,
  method: PaymentQrMethod,
): PaymentQrAssetMeta {
  return invoice.paymentQrAssets[method];
}
